// eslint-disable-next-line import/no-cycle
import { BankFeedUseDummy } from "../../../../../redux/BankFeed/dummy/BankFeedUseDummy";
import { BankFeedConnectionStatus } from "../enums/BankFeedConnectionStatus";
import BankFeedActions from 'bukku/redux/BankFeed/actions';

// export const dummyBankFeeds = [
//     {
//         id: 1,
//         bank_code: 'MBB',
//         bank_name: 'Maybank',
//         bank: 'MAYBANK',
//         bank_description: 'Link up to 3 Maybank accounts',
//         last_sync_at: '2023-11-07 12:00:00',
//         status: BankFeedConnectionStatus.CONNECTED,
//         connected_accounts: [
//             {
//                 id: 1,
//                 bank_code: 'MBB',
//                 account_number: '1234567890',
//                 account_name: 'Maybank Account 1',
//                 currency_code: 'MYR',
//                 bukku_mapping_account_id: 1,
//                 bukku_mapping_account_name: 'Cash Account',
//             },
//             {
//                 id: 2,
//                 bank_code: 'MBB',
//                 account_number: '1234567891',
//                 account_name: 'Maybank Account 2',
//                 currency_code: 'MYR',
//                 bukku_mapping_account_id: 2,
//                 bukku_mapping_account_name: 'Cash Account 2',
//             },
//         ],
//     },
//     {
//         id: 4,
//         bank_code: 'MBB',
//         bank_name: 'Maybank',
//         bank: 'MAYBANK',
//         bank_description: 'Link up to 3 Maybank accounts',
//         last_sync_at: '2023-11-07 13:34:00',
//         status: BankFeedConnectionStatus.PENDING, // <---- THIS IS DIFFERENT
//         connected_accounts: null,
//     },
//     {
//         id: 5,
//         bank_code: 'MBB',
//         bank_name: 'Maybank',
//         bank: 'MAYBANK',
//         bank_description: 'Link up to 3 Maybank accounts',
//         last_sync_at: '2023-11-07 12:00:00',
//         status: BankFeedConnectionStatus.NOT_CONNECTED, // <---- THIS IS DIFFERENT
//         connected_accounts: null,
//     },
//     {
//         id: 6,
//         bank_code: 'MBB',
//         bank_name: 'Maybank',
//         bank: 'MAYBANK',
//         bank_description: 'Link up to 3 Maybank accounts',
//         last_sync_at: '2023-11-07 12:00:00',
//         status: null, // <---- THIS IS DIFFERENT
//         connected_accounts: null,
//     },
//     {
//         id: 2,
//         bank_code: 'PBB',
//         bank_name: 'Public Bank',
//         bank: 'PUBLIC',
//         bank_description: 'Link up to 3 PBB accounts',
//         last_sync_at: null,
//         status: null,
//         connected_accounts: null,
//     },
//     {
//         id: 3,
//         bank_code: 'CIMB',
//         bank_name: 'CIMB',
//         bank: 'CIMB',
//         bank_description: 'Link up to 3 CIMB accounts',
//         last_sync_at: null,
//         status: null,
//         connected_accounts: null,
//     },
// ];

const showMappingModal = BankFeedUseDummy[BankFeedActions.BANK_FEED_MAP_ACCOUNTS_REQUEST];
const showPendingCheckerModal = BankFeedUseDummy.BANK_FEED_PENDING_CHECKER;
const isNotConnected = BankFeedUseDummy[BankFeedActions.BANK_FEED_CONNECT_REQUEST];
// const showMappingModal = true;
export const dummyBankFeedsV2 = [
    !showPendingCheckerModal && {
        id: 1,
        // key: 'MAYBANK',
        bank: 'MAYBANK',
        // eslint-disable-next-line no-nested-ternary
        status: showMappingModal ?
            BankFeedConnectionStatus.CONNECTED :
            (
                isNotConnected ? BankFeedConnectionStatus.NOT_CONNECTED : BankFeedConnectionStatus.CONNECTED
        // || BankFeedConnectionStatus.PENDING
        //  || BankFeedConnectionStatus.NOT_CONNECTED
            ),
        accounts: [
            {
                id: 1,
                linked_account_id: 2,
                ext_id: "2bfce201-1f2f-4d82-a8b8-5b4dcfcb366b",
                ext_number: "*******9961",
                // ext_name: 'Sole Proprietor PCA',
                sync_starts_at: '2023-11-07',
                sync_ends_at: '2023-11-10',
            },
            {
                id: 2,
                linked_account_id: null,
                ext_id: "2bfce201-1f2f-4d82-a8b8-5b4dcfcb366c",
                ext_number: "*******3612",
                // ext_name: 'Current Account',
                sync_starts_at: null,
                sync_ends_at: '2023-11-10',
            },
            // {
            //     id: 3,
            //     linked_account_id: null,
            //     ext_id: "2bfce201-1f2f-4d82-a8b8-5b4dcfcb366d",
            //     ext_number: "*******5544",
            //     ext_name: 'Multi-currency Account',
            //     sync_starts_at: '2023-10-01',
            //     sync_ends_at: '2023-11-10',
            // },
        ],
        is_linked: !showMappingModal,
        created_at: '2023-11-07 12:00:00',
        updated_at: '2023-11-10 12:00:00',
        // lock_connect: false,
        max_connected_accounts: 3,
    },
    showPendingCheckerModal && {
        id: 1,
        // key: 'MAYBANK',
        bank: 'MAYBANK',
        status: BankFeedConnectionStatus.PENDING,
        accounts: [],
        is_linked: false,
        created_at: '2023-11-07 12:00:00',
        updated_at: '2023-11-10 12:00:00',
        // lock_connect: true,
        max_connected_accounts: 3,
    },
];
